import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Checkbox, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
import { AccountFooter } from 'components/Footer/AccountFooter'
import {
  useGetCompanyNameQuery,
  useGetWarehouseLazyQuery,
  useGetAssignedCompanyQuery,
  useGetEntityCoaLazyQuery,
  useGetCostCentreCodeLazyQuery,
} from 'generated/graphql'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { orderBy } from 'lodash'
import React, { Fragment, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation } from 'react-router'
import * as yup from 'yup'

interface ICListingWithStatusParamsFormProps {
    CompanyID: string
    DocNo: string
    DocDate: Date
    TrxnDate: Date
    DocRef: string
    DocType: string
    Description: string
    CostCentreID: string
    WarehouseID: string
    DocAmt: number
    DocStatus: string
}

interface CompanyOption {
    Name: string
    CompanyID: string
}

export const ICListingWithStatusParamsForm = (props: any) => {
    let history = useHistory()
    let location = useLocation()
    const editData = location?.state as any
    const user = JSON.parse(localStorage.getItem('loggedInUser'))
    const latestCompany = localStorage.getItem('latestCompany')
    const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>
    const checkedIcon = <CheckBoxIcon fontSize="small"/>
    const ParamsSchema = yup.object().shape({
        CompanyID: CommonYupValidation.requireField('CompanyID is required'),
        DocDate: CommonYupValidation.requireField(
            'Doc Date is required'
        ),
        TrxnDate: CommonYupValidation.requireField(
            'Trxn Date is required'
        ),
    })

    const {
        handleSubmit,
        register,
        errors,
        control,
        getValues,
        watch,
        setValue,
    } = useForm<ICListingWithStatusParamsFormProps>({
        defaultValues: {},
        mode: 'all',
        resolver: yupResolver(ParamsSchema),
    })

    const {
        loading: CompanyLoading,
        error: companyError,
        data: { getCompany} = { getCompany: [] },
    } = useGetCompanyNameQuery({
        fetchPolicy: 'network-only',
        variables: {
            orderByAsc: 'Name',
        },
        onCompleted: () => {
            if (latestCompany) {
                loadWarehouse({
                    variables: { 
                        orderByAsc: 'Name', 
                    },
                })
                loadCostCentre({
                    variables: {
                        CompanyID: latestCompany,
                        orderByAsc: 'Code',
                        IsLastNode: true,
                    }
                })
                loadEntityCOA({
                    variables: {CompanyID: latestCompany},
                })
            }
        },
    })

    const {
        loading: CompanyAssignedLoading,
        error: CompanyAssignedError,
        data: {getAssignedCompanyByUser} = {getAssignedCompanyByUser: []},
    } = useGetAssignedCompanyQuery({
        fetchPolicy: 'network-only',
        onCompleted: () => {
            if (latestCompany) {
                loadWarehouse({
                    variables: { 
                        orderByAsc: 'Name', 
                    },
                })
                loadCostCentre({
                    variables: {
                        CompanyID: latestCompany,
                        orderByAsc: 'Code',
                        IsLastNode: true,
                    }
                })
                loadEntityCOA({
                    variables: {CompanyID: latestCompany},
                })
            }
        },
    })

    const [
        loadWarehouse,
        {
            loading: WarehouseLoading, 
            error: warehouseError,
            data: {getWarehouse} = {getWarehouse: []},
        },
    ] = useGetWarehouseLazyQuery({
        fetchPolicy: 'network-only',
        onCompleted: ({getWarehouse}) => {},
    })

    const [
        loadEntityCOA,
        {
            loading: EntityCOALoading,
            data: {getEntityCOA} = {getEntityCOA: []},
        },
    ] = useGetEntityCoaLazyQuery({
        fetchPolicy: 'network-only',
    })
    
    const [
        loadCostCentre,
        {
            loading: CostCentreLoading,
            data: {getCostCentre} = {getCostCentre: []},
        },
    ] = useGetCostCentreCodeLazyQuery({
        fetchPolicy: 'network-only',
    })

    const [selectedWarehouse, setselectedWarehouse] = useState(new Set())
    const handleCheckboxWarehouseChange = (event: any) => {
        let warehouse = selectedWarehouse

        if (event?.target?.checked) {
            warehouse.add(event?.target?.value)
        } else {
            warehouse.delete(event?.target?.value)  
        }
        setselectedWarehouse(new Set(warehouse))
    }

    const docTypeArray = [
        {Name: 'Stock Requisition'},
        {Name: 'Stock Issue'},
        {Name: 'Stock Receipt'},
        {Name: 'Stock Transfer'},
        {Name: 'Stock Qty Adjustment'},
        {Name: 'Stock Cost Adjustment'},
        {Name: 'Cycle Count'},
    ]
    const [selectedDocType, setSelectedDocType] = useState(new Set())
    const handleCheckboxDocType = (event: any) => {
        let docType = selectedDocType

        if(event?.target?.checked) {
            docType.add(event?.target?.value)
        } else {
            docType.delete(event?.target?.value)
        }
        setSelectedDocType(new Set(docType))
    }

    const [selectedDepartment, setSelectedDepartment] = useState(new Set())
    const handleCheckboxDepartment = (event: any)=> {
        let department = selectedDepartment

        if(event?.target?.checked) {
            department.add(event?.target?.value)
        } else {
            department.delete(event?.target?.value)
        }
        setSelectedDepartment(new Set(department))
    }

    const statusArray = [
        {Name: 'Draft'},
        {Name: 'Submitted'},
        {Name: 'Approved'},
        {Name: 'Rejected'},
        {Name: 'Cancelled'},
    ]
    const [selectedStatus, setSelectedStatus] = useState(new Set())
    const handleCheckboxStatus = (event: any) => {
        let status = selectedStatus

        if (event?.target?.checked) {
            status.add(event?.target?.value)
        } else {
            status.delete(event?.target?.value)
        }
        setSelectedStatus(new Set(status))
    }

    const onSubmit = data => {
        history.push({
            pathname: '/digital-reports/inventory-control/ic-listing-with-status/generated',
            state: {
                CompanyID: data?.CompanyID ? data?.CompanyID: undefined,
                DocDate: data?.DocDate ? new Date(data.DocDate) : null,
                TrxnDate: data?.TrxnDate ? new Date(data.TrxnDate) : null,
                DocNo: data?.DocNo ? data?.DocNo: undefined,
                DocRef: data?.DocRef ? data?.DocRef: undefined,
                Description: data?.Description ? data?.Description: undefined,
                WarehouseID: selectedWarehouse
                    ? Array.from(selectedWarehouse)?.toString()
                    : undefined,
                DocType: selectedDocType
                    ? Array.from(selectedDocType)?.toString()
                    : undefined,
                CostCentreID: selectedDepartment
                    ? Array.from(selectedDepartment)?.toString()
                    : undefined,
                DocStatus: selectedStatus
                    ? Array.from(selectedStatus)?.toString()
                    : undefined,
                DocAmt: data?.DocAmt ? parseFloat(data?.DocAmt) : undefined,
            },
        })
    }

    return (
        <>
            {CompanyLoading && <Loading />}
            {CompanyAssignedLoading && <Loading />}
            {WarehouseLoading && <Loading />}
            {CostCentreLoading && <Loading />}
            {EntityCOALoading && <Loading />}
            <MainHeader
                mainBtn="back"
                onClick={() => history.push(`/digital-reports/inventory-control`)}
                smTitle={'Inventory Control'}
                title={user?.accontName}
                routeSegments={[
                { name: 'Main Menu' },
                { name: 'Submenu' },
                { name: 'IC Listing With Status', current: true },
                ]}
                rightRouteSegments={[{ name: 'Parameters', current: true }]}
            />
            <ContentWrapper float>
                <CardContents>
                    {!CompanyAssignedLoading && !CompanyLoading && (
                        <Controller
                            render={({ value, onChange }) => {
                                const options: CompanyOption[] =
                                !!user?.superUser === false
                                    ? getAssignedCompanyByUser
                                    : getCompany
                                const defVal = getCompany?.filter(
                                x => x?.CompanyID === latestCompany
                                )[0]
                                return (
                                    <Autocomplete
                                        options={options || []}
                                        getOptionLabel={(option: CompanyOption) => option.Name}
                                        fullWidth
                                        onChange={(value, newValue: any) => {
                                            onChange(newValue?.CompanyID)
                                            loadWarehouse({
                                                variables: {
                                                orderByAsc: 'Name',
                                                },
                                            })
                                            loadEntityCOA({
                                                variables: { CompanyID: newValue?.CompanyID },
                                            })
                                            loadCostCentre({
                                                variables: {
                                                CompanyID: newValue?.CompanyID,
                                                orderByAsc: 'Code',
                                                IsLastNode: true,
                                                },
                                            })
                                        }}
                                        PopperComponent={AccCodeDropdownFullWidth}
                                        renderOption={(props, option) => {
                                        return (
                                            <div>
                                            <div>
                                                <span className="xsTitle">{props?.Name}</span>
                                            </div>
                                            </div>
                                        )
                                        }}
                                        defaultValue={defVal}
                                        renderInput={(params: any) => {
                                            return (
                                                <div>
                                                    <TextField
                                                        {...params}
                                                        helperText={errors?.CompanyID?.message}
                                                        error={errors?.CompanyID ? true : false}
                                                        label="Company"
                                                        style={{ width: '100%' }}
                                                        margin="normal"
                                                        variant="standard"
                                                        required
                                                        defaultValue={defVal}
                                                    />
                                                </div>
                                            )
                                        }}
                                    />
                                )
                            }}
                            label="Company"
                            name="CompanyID"
                            autoComplete="off"
                            control={control}
                            multiline={true}
                            fullWidth
                            margin="normal"
                            ref={register}
                            helperText={errors?.CompanyID?.message}
                            error={errors?.CompanyID ? true : false}
                            required
                            defaultValue={latestCompany}
                        />
                    )}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Controller
                            as={KeyboardDatePicker}
                            name="DocDate"
                            label="Doc Date"
                            control={control}
                            onChange={(date: Date | null) => {}}
                            format="dd/MM/yyyy"
                            value={watch('DocDate')}
                            margin="normal"
                            allowKeyboardControl
                            ref={register}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                            className="left"
                            defaultValue={editData?.StartDate ?? new Date()}
                            helperText={errors?.DocDate?.message}
                            error={errors?.DocDate ? true : false}
                            showTodayButton
                            fullWidth
                            required
                        />
                    </MuiPickersUtilsProvider>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Controller
                            as={KeyboardDatePicker}
                            name="TrxnDate"
                            label="Trxn Date"
                            control={control}
                            onChange={(date: Date | null) => {
                                setValue('TrxnDate', date)
                            }}
                            format="dd/MM/yyyy"
                            value={watch('TrxnDate')}
                            margin="normal"
                            allowKeyboardControl
                            ref={register}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                            className="right"
                            defaultValue={editData?.EndDate ?? new Date()}
                            helperText={errors?.TrxnDate?.message}
                            error={errors?.TrxnDate ? true : false}
                            showTodayButton
                            fullWidth
                            required
                        />
                    </MuiPickersUtilsProvider>

                    <Controller
                        as={TextField}
                        id="standard-basic"
                        name="DocNo"
                        label="Doc No"
                        autoComplete="off"
                        control={control}
                        fullWidth
                        margin="dense"
                        ref={register}
                        helperText={errors?.DocNo?.message}
                        error={errors?.DocNo ? true : false}
                    />

                    <Controller
                        as={TextField}
                        id="standard-basic"
                        name="DocRef"
                        label="Doc Ref"
                        autoComplete="off"
                        control={control}
                        fullWidth
                        margin="dense"
                        ref={register}
                        helperText={errors?.DocRef?.message}
                        error={errors?.DocRef ? true : false}
                    />

                    <Controller
                        as={
                            <NumberFormat
                                allowNegative={false}
                                customInput={TextField}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator
                                isNumericString
                                onValueChange={e => {
                                    setValue('DocAmt', parseFloat(e.value))
                                }}
                            />
                        }
                        name="DocAmt"
                        label="Doc Amount"
                        ref={register()}
                        control={control}
                    />

                    <Controller
                        as={TextField}
                        id="standard-basic"
                        name="Description"
                        label="Description"
                        autoComplete="off"
                        control={control}
                        fullWidth
                        className="dense"
                        margin="dense"
                        ref={register}
                        helperText={errors?.Description?.message}
                        error={errors?.Description ? true : false}
                    />

                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={watch('CompanyID') ? getWarehouse : []}
                                    getOptionLabel={option => `${option?.Name}`}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selected = new Set()

                                        newValue?.map(x => {
                                            selected.add(x?.WarehouseID)
                                        })

                                        setselectedWarehouse(new Set(selected))
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                value={option?.WarehouseID}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                                onChange={event => {
                                                handleCheckboxWarehouseChange(event)
                                                }}
                                            />
                                            {`${option?.Name}`} 
                                        </Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            style={{ width: '100%' }}
                                            label="Warehouse"
                                            margin="normal"
                                        />
                                        )
                                    }}
                                />
                            )
                        }}
                        name="WarehouseID"
                        label="Warehouse"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />
                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={docTypeArray || []}
                                    getOptionLabel={option => `${option?.Name}`}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selected = new Set()

                                        newValue?.map(x => {
                                            selected.add(x?.Name)
                                        })

                                        setSelectedDocType(new Set(selected))
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            value={option?.Name}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                            color="primary"
                                            onChange={event => {
                                            handleCheckboxDocType(event)
                                            }}
                                        />
                                        {`${option?.Name}`}
                                        </Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                style={{ width: '100%' }}
                                                label="Doc Type"
                                                margin="normal"
                                            />
                                        )
                                    }}
                                />
                            )
                        }}
                        name="DocType"
                        label="Doc Type"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />

                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={watch('CompanyID') ? getCostCentre : []}
                                    getOptionLabel={option => `${option?.MasterCode}`}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selected = new Set()

                                        newValue?.map(x => {
                                        selected.add(x?.CostCentreID)
                                        })

                                        setSelectedDepartment(new Set(selected))
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            value={option?.CostCentreID}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                            color="primary"
                                            onChange={event => {
                                                handleCheckboxDepartment(event)
                                            }}
                                        />
                                        {`${option?.MasterCode}`}
                                        </Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            style={{ width: '100%' }}
                                            label="Department"
                                            margin="normal"
                                        />
                                        )
                                    }}
                                />
                            )
                        }}
                        name="CostCentreID"
                        label="Department"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />

                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={statusArray || []}
                                    getOptionLabel={option => `${option?.Name}`}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selected = new Set()

                                        newValue?.map(x => {
                                        selected.add(x?.Name)
                                        })
                                            setSelectedStatus(new Set(selected))
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                value={option}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                                onChange={event => {
                                                    handleCheckboxStatus(event)
                                                }}
                                            />
                                            {`${option?.Name}`}
                                        </Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            style={{ width: '100%' }}
                                            label="Doc Status"
                                            margin="normal"
                                        />
                                        )
                                    }}
                                />
                            )
                        }}
                        name="DocStatus"
                        label="Doc Status"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />
                </CardContents>
                <AccountFooter
                    options={[
                        {
                            name: 'Submit',
                            onClick: () => {
                                handleSubmit(onSubmit)()
                            },
                            color: 'primary',
                        },
                    ]}
                />
            </ContentWrapper>
        </>
    )
}